var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "url(#paint0_linear_5800_24735)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    stroke: "black",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5884 36.8291C23.0979 36.5201 24.4246 35.6283 25.2806 34.3471C26.1365 33.066 26.4527 31.4989 26.1604 29.9861C25.969 29.0538 25.5434 28.1855 24.9237 27.4631C23.5127 25.8759 22.7196 23.8343 22.6891 21.7109V20.7693C22.7058 18.5116 23.5999 16.349 25.1823 14.7386C25.9394 13.9506 26.463 12.9681 26.6948 11.9002C26.9266 10.8324 26.8576 9.7212 26.4954 8.69027C26.1332 7.65935 25.492 6.74914 24.6432 6.06096C23.7945 5.37278 22.7714 4.93362 21.6879 4.79234C20.9324 4.71559 20.1692 4.78946 19.4424 5.00966C18.7156 5.22986 18.0398 5.59204 17.4539 6.07521C16.8681 6.55838 16.3839 7.15295 16.0294 7.82451C15.6748 8.49607 15.4571 9.23129 15.3886 9.98759C15.3004 10.811 15.3855 11.6437 15.6385 12.4323C15.8914 13.2208 16.3066 13.9477 16.8573 14.5662C18.2794 16.1415 19.0703 18.1862 19.0786 20.3085V20.9185C19.0798 22.0772 18.8453 23.2241 18.3894 24.2893C17.9334 25.3546 17.2655 26.316 16.4263 27.115C15.5032 27.9694 14.8889 29.1054 14.6793 30.3456C14.4696 31.5859 14.6764 32.8607 15.2674 33.971C15.8584 35.0814 16.8003 35.9649 17.9461 36.4838C19.092 37.0026 20.3774 37.1275 21.6017 36.8391L21.5884 36.8291Z",
    fill: "url(#paint1_linear_5800_24735)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M23.0179 14.3672C24.6512 14.3672 25.9752 12.5845 25.9752 10.3854C25.9752 8.18628 24.6512 6.40356 23.0179 6.40356C21.3846 6.40356 20.0605 8.18628 20.0605 10.3854C20.0605 12.5845 21.3846 14.3672 23.0179 14.3672Z",
    fill: "url(#paint2_linear_5800_24735)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25.275 31.0271C25.275 33.2252 23.9489 35.0056 22.3177 35.0056C20.6865 35.0056 19.3604 33.2219 19.3604 31.0271C19.3604 28.8323 20.6865 27.0486 22.3177 27.0486C23.9489 27.0486 25.275 28.8223 25.275 31.0271Z",
    fill: "url(#paint3_linear_5800_24735)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90907 26.8497C6.75943 26.485 4.46849 23.5111 4.7934 20.2189C5.11831 16.9267 7.93309 14.5263 11.0927 14.891C14.2523 15.2557 16.5266 18.213 16.2017 21.5284C15.8768 24.8439 13.062 27.2144 9.90907 26.8497Z",
    fill: "url(#paint4_linear_5800_24735)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12.681 24.6881C14.3143 24.6881 15.6383 22.9054 15.6383 20.7063C15.6383 18.5072 14.3143 16.7245 12.681 16.7245C11.0477 16.7245 9.72363 18.5072 9.72363 20.7063C9.72363 22.9054 11.0477 24.6881 12.681 24.6881Z",
    fill: "url(#paint5_linear_5800_24735)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1278 26.8497C27.9782 26.485 25.6872 23.5111 26.0121 20.2189C26.3371 16.9267 29.1518 14.5263 32.3114 14.891C35.471 15.2557 37.7454 18.213 37.4205 21.5284C37.0956 24.8439 34.2808 27.2144 31.1278 26.8497Z",
    fill: "url(#paint6_linear_5800_24735)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M33.8997 24.6881C35.533 24.6881 36.8571 22.9054 36.8571 20.7063C36.8571 18.5072 35.533 16.7245 33.8997 16.7245C32.2664 16.7245 30.9424 18.5072 30.9424 20.7063C30.9424 22.9054 32.2664 24.6881 33.8997 24.6881Z",
    fill: "url(#paint7_linear_5800_24735)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5800_24735",
    x1: 21,
    y1: 0,
    x2: 21,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EFFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBFFF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5800_24735",
    x1: 20.7144,
    y1: 4.76294,
    x2: 20.7144,
    y2: 36.9909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9441FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5800_24735",
    x1: 19.351,
    y1: 10.3854,
    x2: 26.6018,
    y2: 10.3854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EFFDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#4EFFDF",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4EFFDF",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#4EFFDF",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#4EFFDF",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#4EFFDF",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#4EFFDF",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EFFDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5800_24735",
    x1: 18.6509,
    y1: 31.0271,
    x2: 25.9016,
    y2: 31.0271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EFFDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#4EFFDF",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4EFFDF",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#4EFFDF",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#4EFFDF",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#4EFFDF",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#4EFFDF",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EFFDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5800_24735",
    x1: 10.4977,
    y1: 14.8544,
    x2: 10.4977,
    y2: 26.8867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9441FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5800_24735",
    x1: 9.01414,
    y1: 20.7063,
    x2: 16.2649,
    y2: 20.7063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EFFDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#4EFFDF",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4EFFDF",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#4EFFDF",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#4EFFDF",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#4EFFDF",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#4EFFDF",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EFFDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5800_24735",
    x1: 31.7164,
    y1: 14.8544,
    x2: 31.7164,
    y2: 26.8867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9441FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5800_24735",
    x1: 30.2329,
    y1: 20.7063,
    x2: 37.4837,
    y2: 20.7063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EFFDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#4EFFDF",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4EFFDF",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#4EFFDF",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#4EFFDF",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#4EFFDF",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#4EFFDF",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EFFDF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiLogo);
export default __webpack_public_path__ + "static/media/ai-logo.0eea81e54bc3eee366a9b60f847a0b9b.svg";
export { ForwardRef as ReactComponent };